import React from "react";
import { animations } from "react-animation";
import "./SegundaBarra.css";

function SegundaBarra(){
    return (
        <div style={{ animation: animations.fadeIn }}>
          
            <div className="contenedor-barra-segunda">
              <div className="contenido-barra d-flex justify-content-between">
                <div className="descripcionBarraa-segunda">
                Tasa de interés total anual (TITA) Para efectos informativos y comparativos, esta incluye la tasa interés nominal más todos los costos y gastos relacionados al préstamo en los cuales el deudor debe incurrir, expresado en términos porcentuales y traducido en años.
                Tasa de interés nominal mensual de 16,00%. Tasa de interés total anual de 19,87% por un crédito de hasta ₡10.000.000 y a un plazo de hasta 60 meses.
                Ejemplo: Crédito personal de ₡1.000.000 al plazo máximo de 60 meses. Cuota por millón mensual: ₡26.868 aproximadamente. Interés nominal 16,00%. TITA 19,87%. Comisión de formalización de 1,00%. Porcentaje aporte capital 0,75%. Gastos de operación 1,00%. Gastos administrativos ₡7.000.
                </div>          
              </div>
            </div>
        </div>
      )
}
 
    
export default SegundaBarra;